import { AxiosError } from "axios";

import { ADMIN_API_ENDPOINTS } from "@/config/apiEndpoints/adminUrls";
import { handleApiError } from "@/lib/utils";
import adminAxios from "@/lib/axios";

export interface IParaTextPayload {
  id?: number | string;
  page_id?: number;
  component_id?: number;
  variant?: string;
  description?: string;
  desktop_background_color?: string;
  mobile_background_color?: string;
  backvariant?: string;
  gradient_color_1?: string;
  gradient_color_2?: string;
  gradient_color_3?: string;
  gradient_color_4?: string;
  background_color?: string;
  text_color?: string;
  status?: boolean;
  enable_animation?: boolean;
}

export async function createParaText(payload: Partial<IParaTextPayload>) {
  try {
    const response = await adminAxios.post(
      ADMIN_API_ENDPOINTS.PARA_TEXT.CREATE,
      payload
    );

    return response?.status === 201 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

export async function updateParaText(
  id: number,
  payload: Partial<IParaTextPayload>
) {
  try {
    const response = await adminAxios.put(
      ADMIN_API_ENDPOINTS.PARA_TEXT.UPDATE(id),
      payload
    );

    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}
